import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';
import colors from '../../utils/colors';

interface SubHeadingProps extends TextProps {
    children: React.ReactNode;
    size: "xs" | "s"
    color?: string
}

const SubHeading: React.FC<SubHeadingProps> = ({ children, color, size, ...rest }) => {
    return <Text
        {...rest}
        fontSize={size === "xs" ? "12px" : "20px"}
        fontFamily={"lato"}
        fontWeight={400}
        color={color ?? colors.dark}
        lineHeight={size === "xs" ? "14.4px" :"24px"}
    >
        {children}
    </Text>;
};

export default SubHeading;
